import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { SimpleLoadingComponent } from '../../utils/apollo';
import { virtualNotificationTypes } from '../ActivityNotification/constants';
import formatDate from '../../utils/format-date';
import './styles.css';

export class RepVisitsPendingCounterComponent extends React.Component {
  static propTypes = {
    viewer: PropTypes.object,
    refetch: PropTypes.func,
  };

  componentDidMount() {
    this.props.refetch();
  }

  render() {
    const { countRepVisitsNotifications, countCollegeRepVisitsRSVPs, countCollegeFairsRSVPs } = this.props.viewer;
    const notificationsCount = countRepVisitsNotifications + countCollegeRepVisitsRSVPs + countCollegeFairsRSVPs;
    if (!notificationsCount) return null;
    return (
      <div styleName="counter-pending-college-rsvps" data-cy="pending-requests-count">
        {notificationsCount}
      </div>
    );
  }
}

const query = gql`
  query NotificationCount(
      $userBookingStatus: RSVPStatus!,
      $fromDate: OrdinalDate!,
      $toDate: OrdinalDate!,
      $notificationTypes: [RepVisitsNotificationType]
    ) {
    viewer {
      id
      countRepVisitsNotifications(notificationTypes: $notificationTypes)
      countCollegeRepVisitsRSVPs(userBookingStatus: $userBookingStatus, fromDate: $fromDate, toDate: $toDate)
      countCollegeFairsRSVPs(userBookingStatus: $userBookingStatus, fromDate: $fromDate, toDate: $toDate)
    }
  }
`;
const graphqlData = graphql(query, {
  options: {
    variables: {
      userBookingStatus: 'PENDING',
      fromDate: formatDate(new Date()),
      toDate: formatDate(new Date(Date.now() + (1000 * 60 * 60 * 24 * 365))),
      notificationTypes: virtualNotificationTypes,
    },
    fetchPolicy: 'network-only',
  },
});
export default SimpleLoadingComponent(graphqlData)(RepVisitsPendingCounterComponent);
